// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"37ae0af2","72":"d3330773","477":"e2182e6a","627":"91066338","663":"afd08e32","667":"0fa1d068","777":"c789e99c","803":"e533f5c5","820":"47dd5420"}[chunkId] + ".chunk.js";
};